<section id="login">
    <div class="container-fluid">
        <div class="row full-height-vh">
            <div class="col-12 d-flex align-items-center justify-content-center">
                <div class="card gradient-blueberry text-center width-400">
                    <div class="card-body">
                        <div class="card-block">
                            <h2 class="white mt-2 mb-2">{{'forgot_password' | translate}}</h2>
                            <form novalidate="" (ngSubmit)="onSubmit()" #form="ngForm">
                                <div class="form-group" *ngIf="!isSent">
                                    <div class="col-md-12">
                                        <input type="email" class="form-control" name="email" placeholder="E-Mail" ngModel #email="ngModel" minlength="3" required email>
                                    </div>
                                </div>

                                <div class="form-group" *ngIf="isSent">
                                    <div class="row">
                                        <div class="col-md-12">
                                            {{'password_reset_email_sent' | translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" *ngIf="!isSent">
                                    <div class="col-md-12">
                                        <button type="submit" class="btn btn-indigo btn-block btn-raised" [disabled]="form.invalid" [ladda]="loading">{{'send' | translate}}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="float-left"><a (click)="onBack()" class="white">{{'back' | translate}}</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


// WEBPACK FOOTER //
// ./src/app/forgotpassword/forgotPassword.component.html